import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function LinePlayCircleIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="m16 10.27-5-2.89a2 2 0 0 0-3 1.73v5.78a1.9998 1.9998 0 0 0 2 1.9979c.3511 0 .696-.0924 1-.2679l5-2.89a1.9997 1.9997 0 0 0 0-3.46ZM15 12l-5 2.89V9.11L15 12ZM12 2a10 10 0 1 0 0 20.0001A10 10 0 0 0 12 2Zm0 18a8.0005 8.0005 0 0 1-7.391-4.9385A8 8 0 1 1 12 20Z"/>
  </SvgIcon>
}

export default LinePlayCircleIcon
